window.app.controller('formCtrl', ['$http', '$scope', '$compile', function ($http, $scope, $compile){
    $scope.keyPress = function(){
        addEventListener("keydown", function(event) {
            if (event.keyCode == 27) $('.closeBtn').click();
        });
    };
    $scope.keyPress();
    $scope.test='form test';
    $scope.emailUnique = false;
    $scope.emailEnabled = false;

    $scope.formErrorShow = false;
    $scope.formErrorText;
    $scope.formErrorLink;
    $scope.partnerInfo = {};

    $scope.formLinkActive =function(){
        if($('.form__error').attr('href') == '') return "pointer-events: none";
    }

    $scope.emailValue = function(){
        var em = {
            email: $('input[name="email"]').val(),
            isEnabled: 1,
          type: 'user'
        };
        return em;
    };


    $scope.birdthDate = function(){
        var date = function(){
            if(!$('input.md-datepicker-input').val()){
                return new Date($('md-datepicker').attr('data-default-value'))
            }
            return new Date($('input.md-datepicker-input').val())

        };
        var year = ''+(date().getFullYear());
        var month = function(){
            if((date().getMonth()+1+'').length < 2){
                return '0'+(date().getMonth()+1)
            }
            return date().getMonth()+1+''
        };
        var day = function(){
            if((date().getDate() + '').length < 2){
                return '0'+(date().getDate())
            }
            return date().getDate()+''
        };
        return year+'-'+month()+'-'+day()
    }
    $scope.getFormData = function(formName){
        var data = {};
        var inputs = $('[name="' + formName + '"] *[data-default-value]');

        inputs.each(function(){
            var name = $(this).attr('name');
            var value = $(this).val();
            var defVal = $(this).attr('data-default-value');
            var tagName = $(this)[0].tagName;

            if(tagName == 'MD-CHECKBOX') value = $(this).attr('aria-checked');
            if(tagName == 'MD-SELECT') value = $(this).siblings('select').children('option[selected]').val();
            if(tagName == 'MD-DATEPICKER') value = $scope.birdthDate();

            if(value || typeof(value) === "number") data[name] = value;
        })
        console.log(data);
        return data;
    }

    $scope.inputValCtrl = {
        tel: {
            setPrefix: () => {
                let input = $('input[name="tel"]');
                if(!input.val()){
                    input.val('+');
                }
            },
            clear: () => {
                let input = $('input[name="tel"]');
                if(input.val() === '+'){
                    input.val('');
                }

            }
        },
        url: {
            setPrefix: () => {
                let input = $('input[name="url"]');
                if(!input.val()){
                    input.val('https://');
                }
            },
            clear: () => {
                let input = $('input[name="url"]');
                if(input.val() === "https://"){
                    input.val('');
                }
            }
        },
        phone: {
            setPrefix: () => {
                let input = $('input[name="phone"]');
                if(!input.val()){
                    input.val('+');
                }
            },
            clear: () => {
                let input = $('input[name="phone"]');
                if(input.val() === '+'){
                    input.val('');
                }

            }
        },
        clientPhone: {
            setPrefix: () => {
                let input = $('input[name="clientPhone"]');
                if(!input.val()){
                    input.val('+');
                }
            },
            clear: () => {
                let input = $('input[name="clientPhone"]');
                if(input.val() === '+'){
                    input.val('');
                }

            }
        },
        livPostcode: () => {
            var input = $('input[name="livPostcode"]');
            if(input.val().length >= 3 && input.val()[2] !== '-') {
                input.val(input.val().slice(0, 2) + '-' +input.val().slice(2));
            }
        },
        socialNumber: () => {
            var input = $('input[name="socialNumber"]');
            input.val(input.val().toUpperCase());
            if(input.val().length <= 3){
                input.val(input.val().replace(/[\d]/g, ''));
            }
            if(input.val().length > 3){
                input.val(input.val().slice(0,3) + input.val().slice(3).replace(/[a-zA-Z]/g, ''));

            }
        },
        delFailSymbol: (name) => {
            var input = $('input[name="' + name + '"]');
            var pattern = /[' ', '-', '  ', '--', ' -', '\'']/;
            if(pattern.test(input.val())){
                var fw = input.val()[0];
                if(fw == ' ' || fw == '-'||fw=='\'') input.val('');
                input.val(input.val().replace(/  /g, ' '));
                input.val(input.val().replace(/--/g, '-'));
                input.val(input.val().replace(/[\-]+[\s]|[\s]+[\-]|[\']+[\']/g, ''));
            }
        }
    };

    $scope.setInputVal = function(formName){
        var inputs = $('[name="' + formName + '"] *[data-default-value]');
        inputs.each(function(){
            var name = $(this).attr('name');
            var defVal = $(this).attr('data-default-value');

            if(defVal === 'true') defVal = true;
            if(defVal === 'false') defVal = false;
            if(name == 'birthDate' && defVal) defVal=new Date(defVal);

            $scope.partnerInfo[name] = defVal;
        });
        //console.log($scope.person);
    };
    $scope.showTip = () => {
        console.log('xghdh');
    };
}]);



// WEBPACK FOOTER //
// src/js/controllers/forms/formCtrl.js